// extracted by mini-css-extract-plugin
export var aircallIframe = "_lp-3";
export var fabContainer = "_lp-5";
export var fabRinging = "_lp-6";
export var loadingOverlay = "_lp-4";
export var pulse = "_lp-7";
export var widgetContent = "_lp-2";
export var widgetPanel = "_lp-0";
export var widgetPanelExpanded = "_lp-1";